export const DASHBOARD_ROUTE_PREFIXES = [
  "/home",
  "/profile",
  "/engine-config",
  "/api-generator",
  "/my-apis",
  "/gettoken",
  "/subscription",
  "/billing",
  "/help-center",
  "/api-view"
];

export const isDashboardRoute = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return DASHBOARD_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};

export const isProfileRoute = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path === "/profile" || path.startsWith("/profile/");
};

export const isHelpCenterRoute = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path === "/help-center" || path.startsWith("/help-center/");
};

export const isBillingRoute = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path === "/billing" || path.startsWith("/billing/");
};
